import React from "react";
import restrictedImg from "../../Assets/Images/Restricted2.png";
import restrictedAnimatedImg from "../../Assets/Images/Restricted403.webp";
import restrictedDarkImg from "../../Assets/Images/Restricted403Dark.png";
import restrictedDarkAnimatedImg from "../../Assets/Images/Restricted403Dark.webp";
import { useThemeMode } from "../../Context/ThemeContext";
import { useNavigate } from "react-router-dom";
import { APPRoutes } from "../../Utils/Route";

const ART = {
    light: { still: restrictedImg, animated: restrictedAnimatedImg },
    dark: { still: restrictedDarkImg, animated: restrictedDarkAnimatedImg },
};

const Restricted = () => {
    const navigate = useNavigate();
    const { resolvedMode } = useThemeMode();
    const { still, animated } = ART[resolvedMode] || ART.light;

    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center"
            style={{
                background:
                    "radial-gradient(circle at 85% 15%, rgba(var(--hc-gradient-mid-rgb), 0.28) 0%, rgba(var(--hc-gradient-mid-rgb), 0) 40%), " +
                    "radial-gradient(circle at 10% 85%, rgba(var(--hc-gradient-end-rgb), 0.22) 0%, rgba(var(--hc-gradient-end-rgb), 0) 35%), " +
                    "radial-gradient(circle at 35% 15%, rgba(var(--hc-gradient-start-rgb), 0.12) 0%, rgba(var(--hc-gradient-start-rgb), 0) 45%), " +
                    "linear-gradient(135deg, var(--hc-standalone-bg-start) 0%, var(--hc-standalone-bg-mid) 45%, var(--hc-standalone-bg-end) 100%)",
            }}
        >
            <div className="container px-md-5">
                <div className="row align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
                    {/* LEFT */}
                    <div className="col-12 col-lg-6 p-md-5 px-5 order-2 order-lg-1">
                        <h1 className="fw-bold display-2 mb-2" style={{ color: "var(--hc-teal-text)" }}>
                            403
                        </h1>
                        <h2 className="fw-semibold fs-2 mb-3" style={{ color: "var(--hc-heading-dark)" }}>
                            Access Forbidden
                        </h2>
                        <p className="mb-4 fs-5" style={{ color: "var(--hc-text-muted-slate)" }}>
                            You don’t have permission to access this page. Please go back to home or contact your administrator.
                        </p>
                        <div className="d-flex flex-column flex-md-row gap-3">
                            <button
                                className="btn w-100 fw-semibold text-light px-4 py-2 rounded-4 border-0 hc-btn-primary-gradient"
                                style={{ fontSize: "1.1rem" }}
                                onClick={() => navigate(-1)}
                            >
                                Go Back
                            </button>
                            <button
                                className="btn btn-outline-primary px-4 py-2 w-100 rounded-4 fw-semibold"
                                style={{ fontSize: "1.1rem", borderWidth: 2 }}
                                onClick={() => navigate(APPRoutes.LOGIN)}
                            >
                                Home
                            </button>
                        </div>
                    </div>
                    {/* RIGHT */}
                    <div className="col-12 col-lg-6 order-1 order-lg-2 d-flex justify-content-center align-items-center py-4">
                        <picture>
                            {/* The animated picture is skipped for people who ask for reduced motion */}
                            <source srcSet={animated} type="image/webp" media="(prefers-reduced-motion: no-preference)" />
                            <img
                                src={still}
                                alt="403 Forbidden"
                                className="w-100"
                                style={{ maxWidth: 980 }}
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Restricted;
